<template>
  <vs-sidebar
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="$parent.active"
  >
    <div
      class="float-left pl-0 pr-0 collapse width show"
      id="sidebar"
    >
      <div
        class="list-group border-0 card text-center text-lg-left"
        ref="Sidebar"
      >
        <div
          v-if="is_desktop"
          class="d-flex align-items-center justify-content-center"
          style="padding: 16px 11px 4px;"
        >
          <div
            class="text-left account-desktop p-0 cursor"
            v-on:click="$router.replace('/')"
          >
            <img
              height="40"
              :src="icon.menu_logo_icon"
            >
          </div>
        </div>
        <!-- User box for mobile -->
        <div
          v-else-if="!$parent.isNoLogin"
          class="account text-left"
        >
          <div class="pb-2">
            <div class="p-0 email">
              <img
                v-if="$parent.profile_picture != null && $parent.profile_picture != ''"
                :src="$parent.profile_picture"
                style="height: 56px;"
                class="avatar"
              >
              <img
                v-else
                :src="$parent.icon.user_icon"
                style="height: 56px;"
              >
            </div>
          </div>
          <div
            class="text-white fullname"
            v-if="$parent.is_login"
          >
            {{ $parent.fullname }}
          </div>
          <router-link
            v-else
            to="/login"
            class="text-decoration-none"
            v-on:click="$parent.close"
          >
            <div class="text-white fullname">
              {{ $t('message.login.title') }}
            </div>
          </router-link>
        </div>
        <div
          v-else
          class="d-flex align-items-center justify-content-center"
          style="padding: 16px 11px 4px;"
        >
          <div
            class="text-left p-0 cursor"
            v-on:click="$router.replace('/')"
          >
            <img
              height="40"
              :src="icon.menu_logo_icon"
            >
          </div>
        </div>

        <div class="d-flex flex-column justify-content-between text-lg" style="height: 100%; overflow-y: auto;">
          <!-- Top menu -->
          <div class="text-left py-2">
            <router-link
              to="/bus"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.bus_icon"
                >{{ $t('message.bus.menu') }}
              </div>
            </router-link>
            <router-link
              v-if="!$parent.isNoLogin"
              to="/favorite"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.fav_icon"
                >{{ $t('message.favorite.title') }}
              </div>
            </router-link>
            <router-link
              to="/landmark"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.landmark_icon"
                >{{ $t('message.landmark.title') }}
              </div>
            </router-link>
            <router-link
              to="/traffic"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.traffic_icon"
                >{{ $t('message.traffic.title') }}
              </div>
            </router-link>
            <router-link
              to="/event"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.event_icon"
                >{{ $t('message.event.title') }}
              </div>
            </router-link>
            <router-link
              v-if="!$parent.isNoLogin"
              to="/announce"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.announce_icon"
                >{{ $t('message.announce.title') }}
              </div>
            </router-link>
            <router-link
              to="/news"
              v-on:click="$parent.close"
            >
              <div
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.news_icon"
                >{{ $t('message.news.title') }}
              </div>
            </router-link>
          </div>
          <!-- Bottom menu -->
          <div class="config text-left pt-2">
            <router-link
              to="/setting"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.setting_icon"
                >{{ $t('message.setting.title') }}
              </div>
            </router-link>
            <div @click.prevent="isLangEn = !isLangEn">
              <div
                href="#"
                class="list-group-item d-flex align-items-center justify-content-between collapsed"
                data-parent="#sidebar"
              >
                <div>
                  <img
                    class="menu"
                    style="width: 24px; margin-right: 20px;"
                    :src="$parent.icon.language_icon"
                  >{{ $t('message.setting.language') }}
                </div>
                <div class="custom-switch custom-switch-label-enth">
                  <input
                    v-model="isLangEn"
                    class="custom-switch-input"
                    id="language_switch"
                    type="checkbox"
                  >
                  <label class="custom-switch-btn" for="language_switch"></label>
                </div>
              </div>
            </div>
            <router-link
              to="/support"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.support_icon"
                >{{ $t('message.support.title') }}
              </div>
            </router-link>
            <a
              :href="feedback_url"
              @click="$parent.closeWithPropagation"
              target="_blank"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.feedback_icon"
                >{{ $t('message.feedback.title') }}
              </div>
            </a>
            <router-link
              to="/opendata"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.open_data_icon"
                >{{ $t('message.opendata.title') }}
              </div>
            </router-link>
            <router-link
              to="/about"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.info_icon"
                >{{ $t('message.about.title') }}
              </div>
            </router-link>
            <router-link
              to="/privacy"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.privacy_icon"
                >{{ $t('message.privacy.title') }}
              </div>
            </router-link>
            <router-link
              to="/logout"
              v-on:click="$parent.close"
            >
              <div
                href="#"
                class="list-group-item d-flex align-items-center collapsed"
                data-parent="#sidebar"
                v-if="$parent.is_login"
              >
                <img
                  class="menu mr-4"
                  style="width: 20px;"
                  :src="$parent.icon.logout_icon"
                >{{ $t('message.logout') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: 'MenuBar',
  data () {
    return {
      is_desktop: this.$parent.isDesktop(),
      feedback_url: process.env.FEEDBACK_URL,
      icon: {
        menu_logo_icon: require('@/assets/menu_logo_white.svg'),
      },
      isLangEn: null
    }
  },
  watch: {
    isLangEn (value, oldVal) {
      if (oldVal !== null) {
        this.setUILanguage(value ? 'en' : 'th')
        this.setMapLanguage(value ? 'en' : 'th')
      }
    }
  },
  mounted () {
    this.isLangEn = (this.$i18n.locale == 'en')
  },
  methods: {
    setUILanguage (value) {
      this.$parent.config.uiLocale = value
      this.setConfig()

      this.$i18n.locale = value
      this.$parent.getTags()
      this.$parent.getEvents()
    },
    setMapLanguage (value) {
      this.$parent.config.mapLocale = value
      this.setConfig()

      const map = this.$parent.map
      if (map != null) {
        map.language(value)
        map.Layers.setBase(value === 'th' ? longdo.Layers.LIGHT_POI : longdo.Layers.LIGHT_POI_EN)
      }
    },
    async setConfig () {
      const scope = this
      // save config (online)
      if (this.$parent.is_login) {
        // WS-115
        var url = process.env.API_URL + '/front/user/config/save'
        const data = { 'config': JSON.stringify(scope.$parent.config) }

        const apiResult = await this.Api.Call({
          method: 'POST',
          path: url,
          data: data,
        });

        if (apiResult.code === 200 && apiResult.data) {
          console.log('config successfully.')
        } else {
          console.log('config failed.')
        }
      }
      // save config (offline)
      localStorage.setItem('settings', JSON.stringify(scope.$parent.config))
    },
  }
};
</script>

<style lang="scss">

.sidebarx {
  .vs-sidebar, .vs-sidebar--items {
    background-color: rgba(var(--vs-primary), 1);
    border-radius:  0 10px 10px 0;
  }
  .account {
    margin: 16px 12px;
    padding: 12px;
    background: #81A9F8;
    border-radius: 10px;
    position: relative;
  }
}

.material-icon {
  vertical-align: middle !important;
  color: #005eac !important;
  width: 24px !important;
  font-size: 24px !important;
}

@media (min-width: 1024px) {
  .material-icon {
    width: 30px !important;
    font-size: 30px !important;
  }
}
</style>

<style lang="scss">
@import '@/styles/customswitch.scss';
</style>
